
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CarbonFiberEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (40 + layerIndex * 20) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / (layerIndex + 1);
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    const toggle = (Math.floor(x / spacing) + Math.floor(y / spacing)) % 2 === 0;
                    ctx.save();
                    ctx.translate(x, y);
                    if (!toggle) ctx.rotate(Math.PI / 2);
                    
                    const w = spacing * 0.8 * scale;
                    const h = spacing * 0.3 * scale;
                    ctx.fillRect(-w/2, -h/2, w, h);
                    ctx.fillRect(-w/2, h/2, w, h);
                    ctx.restore();
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
